import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { ThemeProvider } from './layout/theme'
import { captureInboundRefCode } from './lib/referral-link'
// Faces before tokens: theme.css names these families in --font-display/--font-sans/
// --font-mono, so the @font-face rules have to be declared first.
import './styles/fonts.css'
import './styles/theme.css'

/*
 * Read `?ref=` before React mounts.
 *
 * Before, and outside the tree, for two reasons: the router rewrites the URL as soon as
 * it takes over, so a component reading the query later may find it already gone; and
 * StrictMode double-invokes effects in development, which would run a capture-and-strip
 * twice and make the second pass see nothing. Doing it once, here, sidesteps both.
 */
captureInboundRefCode()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found in index.html')

createRoot(container).render(
  <StrictMode>
    {/*
     * Above the router, not inside the shell: the provider is pure context with no router
     * dependency, and mounting it here means the theme is available to anything that ever
     * renders outside AppShell — the router's own errorElement included, which is exactly
     * the screen you do not want rendering in the wrong palette.
     */}
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
